<template>
    <div class="page">
        <div class="heading">АКТ ПРИЙОМУ-ПЕРЕДАЧІ НЕВИКЛЮЧНИХ МАЙНОВИХ ПРАВ<br>
            на право використання програмного продукту {{ startPayInfo.billNumber }}
        </div>
        <div class="header cf">
            <p class="header__location">м. Київ</p>
            <p class="header__date">{{ startPayInfo.actDate }} р.</p>
        </div>
        <div class="text">
            <p><b>Ліцензіар</b>: {{ startPayInfo.ourName }}
                <span v-if="includePhysicalWord(startPayInfo.ourName)">(ідентифікаційний код {{
                    startPayInfo.ourINN
                    }})</span>
                <span v-else>(ідентифікаційний код {{ startPayInfo.ourEdrpou }})</span>
                , з однієї сторони, та</p>
            <p><b>Ліцензіат</b>: {{ startPayInfo.customerCompanyName }} ({{ companyType }}) з іншої сторони,
                а разом надалі за текстом цього Акту іменуються як «Сторони», а кожний окремо – як «Сторона»,
                уклали та підписали цей акт прийому-передачі невиключних майнових прав на право використання програмного
                продукту (надалі - Акт) відповідно до ліцензійного договору із сервіс кодом №
                {{ startPayInfo.serviceCode }}
                (надалі - Договір), про наступне:
            </p>
            <p>1. На виконання вимог Ліцензійного договору Ліцензіар передає, а Ліцензіат приймає невиключне майнове
                право
                (невиключну ліцензію) на використання програмного продукту {{ startPayInfo.serviceName }} у вигляді
                інтернет-магазину із
                сервіс кодом {{ startPayInfo.serviceCode }}:
            </p>
            <table class="services">
                <thead>
                <tr>
                    <th>№</th>
                    <th>Найменування</th>
                    <th>Од. вим.</th>
                    <th>Кількість</th>
                    <th>Ціна без ПДВ*</th>
                    <th>Сума без ПДВ*</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>1</td>
                    <td style="text-align: left;">
                        Плата за користування невиключною ліцензією (ліцензійна винагорода) на використання програмного
                        продукту
                        {{ startPayInfo.serviceName }} у вигляді інтернет-магазину із сервіс кодом
                        {{ startPayInfo.serviceCode }}
                    </td>
                    <td style="text-align: left;">{{ startPayInfo.unit }}</td>
                    <td style="text-align: left;">1</td>
                    <td style="text-align: left;">{{ amount }}</td>
                    <td style="text-align: left;">{{ amount }}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <td colspan="5" style="text-align: end">Всього до сплати:</td>
                    <td style="text-align: start">{{ amount }}</td>
                </tr>
                </tfoot>
            </table>
            <p>2. Невиключні майнові права (невиключна ліцензія) передаються Ліцензіату на весь строк користування
                інтернет-магазином з
                моменту підписання цього Акту та розповсюджуються на весь світ.
            </p>
            <p>3. Сторони претензій та зауважень одна до одної не мають.</p>
            <p>4. Цей Акт є підставою для проведення розрахунків між Ліцензіатом та Ліцензіаром відповідно до
                Ліцензійного
                договору, складено в двох оригінальних примірниках українською мовою (а в випадку підписання в
                електронному
                вигляді - одному примірнику), по одному примірнику для кожної із Сторін.</p>
            <p>* операції звільнені від оподаткування ПДВ відповідно до пп. 196.1.6 ст. 196 ПК України,
                оскільки сама виплата винагороди є роялті відповідно до пп. 14.1.225 п. 14.1 ст. 14 ПК України.</p>
        </div>
        <div class="heading">РЕКВІЗИТИ І ПІДПИСИ СТОРІН:</div>
        <div class="requisites cf">
            <div class="requisites__col">
                <p><strong><u>Ліцензіар:</u></strong></p>
                <p><strong>{{ startPayInfo.ourName }}</strong></p>
                <p v-if="includePhysicalWord(startPayInfo.ourINN)">РНОКПП {{ startPayInfo.ourINN }}</p>
                <p v-else>код ЄДРПОУ {{ startPayInfo.ourEdrpou }}</p>
                <p>Місцезнаходження:</p>
                <p>{{ startPayInfo.address }},</p>
                <p>
                    IBAN {{ startPayInfo.IBAN }} <br>
                    {{ startPayInfo.bank }} <br>
                </p>
                <p>еmail: act@horoshop.ua</p>
            </div>
            <div class="requisites__col">
                <p><strong><u>Ліцензіат:</u></strong></p>
                <p><strong>{{ startPayInfo.customerName }}</strong></p>
                <p v-if="act.legal_address">Юридична адреса: {{ act.legal_address }}</p>
                <p v-if="act.actual_address">Адреса фактична: {{ act.actual_address }}</p>
                <p v-if="getInn && getCompanyType === 0 || getCompanyType === 1 || getCompanyType === 4">РНОКПП: {{ getInn }}</p>
                <p v-if="getEdrpou && getCompanyType === 2 || getCompanyType === 3">ЄДРПОУ: {{ getEdrpou }}</p>
                <p v-if="getInn && getCompanyType === 2">IПН: {{ getInn }} </p>
                <p v-if="getIban">IBAN: {{ getIban }}</p>
            </div>
        </div>
        <div class="signatures">
            <div class="signatures__cols cf">
                <div class="signatures__col">
                    <div class="signature">
                        <div class="signature__placeholder"></div>
                        <div class="signature__caption">
                            (підпис)
                        </div>
                        <div class="signature__initials">
                            Директор Шрамко А.К.
                        </div>
                    </div>
                </div>
                <div class="signatures__col">
                    <div class="signature">
                        <div class="signature__placeholder"></div>
                        <div class="signature__caption">
                            (підпис)
                        </div>
                        <div class="signature__initials">
                            {{ getUserPosition }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from 'mixins/api'

export default {
  name: 'ActStartPayView',

  props: {
    bill: Object,
    act: Object,
  },

  mixins: [
    api,
  ],

  data () {
    return {
      startPayInfo: {},
    }
  },

  methods: {
    fetchStartPayData () {
      this.api.get(`/projects/${ this.bill.project.id }/acts/start-pay-data/${ this.bill.id }`).then(response => {
        this.startPayInfo = response.data
      }).catch(error => {
        console.error(error)
      })
    },

    includePhysicalWord (str) {
      if (typeof str === 'undefined') {
        return false
      }

      return str.includes('Фізична')
    },
  },

  computed: {
    inn () {
      if (typeof this.startPayInfo.ourName === undefined) {
        return false
      }

      return this.startPayInfo.ourName.includes('Фізична')
             ? `(ідентифікаційний код ${ this.startPayInfo.ourINN })`
             : `(ідентифікаційний код ${ this.startPayInfo.ourEdrpou })`
    },

    getEdrpou () {
      return this.startPayInfo.clientEdrpou
    },

    getIban () {
      return this.startPayInfo.iban
    },

    getInn () {
      return this.startPayInfo.ipn
    },

    getCompanyType () {
      return this.act.company_type
    },

    amount () {
      const amount = this.startPayInfo.amount

      if (typeof amount !== 'undefined') {
        return amount.toString().includes('.') ? amount : amount.toString().concat('.00')
      }
    },

    getUserPosition () {
      switch (this.act.company_type) {
        case '0':
          return this.act.full_name
                 ? this.act.full_name
                 : `${ this.bill.project.owner.first_name } ${ this.bill.project.owner.last_name }`
        case '1':
        case '4':
          return this.act.company_name
        default:
          return `${ this.act.user_position } ${ this.act.full_name }`
      }
    },

    companyType () {
      return this.act.company_type === 0 || this.act.company_type === 1 || this.act.company_type === 4
             ? `РНОКПП ${ this.getInn }`
             : `ідентифікаційний код ${ this.getEdrpou }`
    },
  },

  created () {
    this.fetchStartPayData()
  },
}
</script>

<style scoped>
.page {
    max-width: 800px;
    margin: 0 auto;
    font-size: 10px;
    line-height: 1.4;
    font-family: "DejaVu Serif", serif;
}

.page p {
    margin: 0 0 5px;
}

.heading {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
}

.header {
    margin-bottom: 15px;
    font-weight: bold;
    font-size: 12px;
}

.header__location {
    float: left;
}

.header__date {
    float: right;
}

.services {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 15px;
}

.services th, .services td {
    padding: 5px;
    border: 1px solid #000;
    text-align: center;
}

.requisites {
    margin-top: 10px;
}

.requisites__col {
    float: left;
    width: 50%;
}

.signatures {
    margin-top: 30px;
}

.signatures__heading {
    margin-bottom: 15px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
}

.signatures__col {
    float: left;
    width: 50%;
}

.signature__head {
    font-size: 14px;
    font-weight: bold;
}

.signature__placeholder {
    position: relative;
    width: 200px;
    height: 80px;
    border-bottom: 2px solid #000;
}

.signature__img {
    position: absolute;
    top: 0;
    width: 210px;
    z-index: -1;
}

.signature__caption {
    width: 200px;
    text-align: center;
}

.signature__initials {
    margin-top: 20px;
    font-size: 12px;
    font-weight: bold;
}

.cf::after {
    content: "";
    clear: both;
    display: table;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/ActStartPayView.vue